enum TabNames {
  cabinet = 'cabinet',
  shelves = 'shelves',
  options = 'options',
}

export default TabNames;
